import { useMutation } from '@tanstack/react-query';
import { POST, POST_CLAIM_REVERT_REJECT } from '../../../../services';

// ถอยได้เฉพาะเคลมที่ไม่อนุมัติ ตรงกับเงื่อนไขใน WRAS_Claims_Admin_Revert_Reject
export const canRevertReject = (claim) => claim?.claimStatus === 'REJECTED';

export const useRevertReject = ({ onSuccess }) =>
  useMutation({
    mutationFn: ({ claimId }) => POST(POST_CLAIM_REVERT_REJECT(), { claimId }),
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
  });
